import React from 'react'
import cn from 'classnames'

export default function Right({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        {
          'col-auto': !className?.includes('col-'),
          'd-flex': !className?.includes('d-none'),
        },
        'align-items-center',
        className,
      )}
    >
      {children}
    </div>
  )
}
